const features = [
  {
    icon: 'ri-customer-service-2-line',
    title: 'Atención Personalizada',
    desc: 'Te asesoramos en cada compra',
  },
  {
    icon: 'ri-medal-line',
    title: 'Productos de Calidad',
    desc: 'Selección exclusiva y premium',
  },
  {
    icon: 'ri-whatsapp-line',
    title: 'Compra Fácil por WhatsApp',
    desc: 'Respuesta rápida y segura',
  },
  {
    icon: 'ri-truck-line',
    title: 'Envío Seguro',
    desc: 'Entrega confiable a tu puerta',
  },
];

export default function FeaturesBar() {
  return (
    <section className="py-12 md:py-16 px-6 bg-sand/20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {features.map((f) => (
            <div
              key={f.title}
              className="flex flex-col items-center text-center group transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-white mb-4 group-hover:shadow-md transition-all duration-300">
                <i className={`${f.icon} text-2xl md:text-3xl text-gold group-hover:scale-110 transition-transform duration-300`} />
              </div>
              <h3 className="font-sans font-semibold text-sm md:text-base text-charcoal mb-2 leading-tight">
                {f.title}
              </h3>
              <p className="font-sans text-xs md:text-sm text-gray-medium leading-relaxed">
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
